import { useState, useEffect, useCallback } from "react";
import { useLocation, Link } from "react-router-dom";
import Layout from "@/components/Layout";
import { getCasinoGameDetails, getMatchExposure } from "@/services/casinoApi";
import BetTableCmeter from "../components/cmeter/BetTableCmeter";
import ResultCmeter from "../components/cmeter/ResultCmeter";
import RightSection from "../components/RightSection/RightSection";
import styles from "./Cmeter.module.css";
import VideoBox from "../components/common/VideoBox";
import CasinoHeading from "../components/common/CasinoHeading";

function extractCasinoGame(url) {
  const match = url.match(/\/lord-games\/([^/?#]+)/);
  return match ? match[1] : null;
}

// Helper function to normalize string for matching
const normalizeString = (str) => {
  if (!str) return "";
  return str.replace(/\s+/g, ' ').trim().toLowerCase();
};

// Helper function to create all exposure key variations
const createExposureKeys = (selection) => {
  if (!selection) return [];
  const keys = [
    selection,
    selection.toLowerCase(),
    selection.toLowerCase().trim(),
    selection.trim(),
    normalizeString(selection),
  ];
  return [...new Set(keys.filter(k => k))];
};

export default function Cmeter() {
  const [gameData, setGameData] = useState({});
  const [activeTab, setActiveTab] = useState("game");
  const [iframeSrc, setIframeSrc] = useState("");
  const { pathname } = useLocation();
  const [exposures, setExposures] = useState({});
  const [myBets, setMyBets] = useState([]);

  useEffect(() => {
    const name = extractCasinoGame(pathname) || "cmeter";
    setIframeSrc(`https://casino-stream.softgamingapi.com/casino-tv?id=${name}`);

    const fetchGameData = async () => {
      try {
        const response = await getCasinoGameDetails(name);
        setGameData(response);
      } catch (err) {
        console.error("Error fetching game data:", err);
      }
    };

    // Start API calls after 5 seconds delay
    let intervalId = null;
    const initialTimeout = setTimeout(() => {
      fetchGameData();
      intervalId = setInterval(fetchGameData, 1500);
    }, 5000);

    return () => {
      clearTimeout(initialTimeout);
      if (intervalId) {
        clearInterval(intervalId);
      }
    };
  }, [pathname]);

  const fetchExposure = useCallback(async () => {
    try {
      const user = JSON.parse(localStorage.getItem('user') || '{}');
      const userId = user?.user_id || user?.id;
      const matchId = gameData?.data?.data?.mid?.toString();

      if (userId && matchId) {
        const response = await getMatchExposure(userId, matchId);
        if (response.success && response.data) {
          const exposureMap = {};
          response.data.forEach((item) => {
            const teamName = item.team_name || item.selection || item.player_name || "";
            const exposureAmount = parseFloat(item.exposure_amount) || 0;
            if (teamName && exposureAmount !== 0) {
              // Create keys for the team name as-is
              const keys = createExposureKeys(teamName);
              keys.forEach(key => {
                if (key) exposureMap[key] = exposureAmount;
              });
            }
          });
          setExposures(prev => ({ ...prev, ...exposureMap }));
        }
      }
    } catch (error) {
      console.error('Error fetching exposure:', error);
    }
  }, [gameData?.data?.data?.mid]);

  useEffect(() => {
    const matchId = gameData?.data?.data?.mid?.toString();
    if (!matchId) return;

    const timeoutId = setTimeout(() => {
      fetchExposure();
    }, 5000);

    const intervalId = setInterval(() => {
      fetchExposure();
    }, 5000);

    return () => {
      clearTimeout(timeoutId);
      clearInterval(intervalId);
    };
  }, [gameData?.data?.data?.mid, fetchExposure]);

  const handleTabChange = (tab) => {
    setActiveTab(tab);
  };

  const handleBetClick = (value, selection, betData, type) => {
    // Betting functionality can be added later (admin view - no bet login)
    console.log("Bet clicked:", { value, selection, betData, type });
  };

  return (
    <Layout>
      <div className={styles.container}>
        <div className={styles.sectionA}>
          <CasinoHeading
            name="CARD METER"
            roundId={gameData?.data?.data?.mid || "157250124095658"}
            placedBetCount={myBets.length}
            activeTab={activeTab}
            onTabChange={handleTabChange}
          />

          {activeTab === "game" && (
            <>
              <VideoBox
                gameType="cmeter"
                resultData={gameData?.data?.data?.card}
                iframeSrc={iframeSrc}
                timerValue={gameData?.data?.data?.lt}
              />

              <div className={styles.tableContainer}>
                <BetTableCmeter
                  data={gameData?.data?.data?.sub || gameData?.data?.sub || []}
                  exposures={exposures}
                  gameData={gameData?.data?.data || gameData?.data || gameData || {}}
                />
              </div>

              <div className={styles.heading}>
                <div>Last Result</div>
                <Link to="/admin/reports/casinoresult/cmeter">
                  <div className={styles.viewAll}>View All</div>
                </Link>
              </div>
              <ResultCmeter
                data={gameData?.lrs || []}
                gameData={gameData}
                gameType="cmeter"
              />
            </>
          )}

        </div>

        <RightSection
          sectionKey="cmeter"
          data={myBets}
          title="Matched"
          viewMoreText="View More"
          onViewMore={() => {
            // Handle view more action
            console.log("View more clicked for cmeter");
          }}
        />
      </div>
    </Layout>
  );
}

